module.exports = new __parcel__URL__("CantViewDark.ef25ef94.svg").toString();